import { SET_TRIPS, GET_TRIPS } from './actionTypes'

export function setTrips(data) {
  return {
    type: SET_TRIPS,
    data,
  }
}

export function getTripsSaga(data) {
  return {
    type: GET_TRIPS,
    data,
  }
}
